import axios from '../axiosInstance';
import { PaginatedResponse } from '../types';

export type RuianAddressGetParams = {
  search?: string;
  limit?: number;
  offset?: number;
};

export type RuianAddress = {
  id: number;
  municipality_name: string;
  municipality_district_name: string | null;
  street_name: string | null;
  house_number: string | null;
  orientation_number: string | null;
  zip_code: string;
};

export const formatRuianAddress = (a: RuianAddress): string => {
  const street = a.street_name
    ? `${a.street_name} ${a.house_number ?? ''}${a.orientation_number ? `/${a.orientation_number}` : ''}`
    : `${a.municipality_district_name ?? ''} ${a.house_number ?? ''}`;
  return `${street.trim()}, ${a.zip_code} ${a.municipality_name}`;
};

const ENDPOINT = '/references/ruian-addresses/';

export const RuianApi = () => ({
  get: (params?: RuianAddressGetParams) =>
    axios.get<PaginatedResponse<RuianAddress>>(ENDPOINT, { params }),

  getOneById: (id: number) =>
    axios.get<RuianAddress>(`${ENDPOINT}${id}/`),
});
